export default __webpack_public_path__ + "static/media/Card Payment_Isometric.eca3a27e.svg";